import img1 from './10001.jpg';
import img2 from './10002.jpg';
import img3 from './10003.jpg';
import img5 from './10005.jpg';
import img6 from './10006.jpg';
import img7 from './10007.jpg';
import img8 from './10008.jpg';
import img9 from './10009.jpg';


export const img = [img1, img2, img3, img5, img6, img7, img8, img9];